import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL + 'districts';

// Get token from localStorage
const getToken = () => localStorage.getItem('token');

// Create axios instance with auth header
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const districtService = {
  // Get all districts
  getDistricts: async (cityId = null) => {
    const url = cityId ? `/?cityId=${cityId}` : '/';
    const response = await axiosInstance.get(url);
    return response.data;
  },

  // Create new district
  createDistrict: async (districtData) => {
    const response = await axiosInstance.post('/', districtData);
    return response.data;
  },

  // Update district
  updateDistrict: async (id, districtData) => {
    const response = await axiosInstance.put(`/${id}`, districtData);
    return response.data;
  },

  // Delete district
  deleteDistrict: async (id) => {
    const response = await axiosInstance.delete(`/${id}`);
    return response.data;
  },

  // Update districts order
  updateOrder: async (districts) => {
    const response = await axiosInstance.put('/reorder', { districts });
    return response.data;
  }
};
